import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { setListeCouches } from '../redux/actions'

function ListeCouches({ afficherlistecouches, setListeCouches, territoire }) {

    const [bouchesdurhone, setBouchesDuRhone] = useState(true);
    const [ct, setCT] = useState(false);
    const [metropole, setMetropole] = useState(false);
    const [communesavecarrondissement, setCommunesAvecArrondissement] = useState(false);
    const [communessansarrondissement, setCommunesSansArrondissement] = useState(false);
    const [polesurbain, setPolesUrbain] = useState(false);
    const [tachesurbaine, setTachesUrbaine] = useState(false);

    useEffect(() => {
        if (territoire === "Métropole") {
            setMetropole(true);
            setBouchesDuRhone(false);
        }
        else {
            setMetropole(false);
            setBouchesDuRhone(true);
        }
    }, [territoire])

    var liste = [];
    if (bouchesdurhone) { liste.push("bouchesdurhone") }
    if (ct) { liste.push("ct") }
    if (metropole) { liste.push("metropole") }
    if (communesavecarrondissement) { liste.push("communesavecarrondissement") }
    if (communessansarrondissement) { liste.push("communessansarrondissement") }
    if (polesurbain) { liste.push("polesurbain") }
    if (tachesurbaine) { liste.push("tachesurbaine") }
    useEffect(() => {
        setListeCouches(liste);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bouchesdurhone, ct, metropole, communesavecarrondissement, communessansarrondissement, polesurbain, tachesurbaine, territoire]);

    return (
        afficherlistecouches ?
            <div id="listecouches">
                <div id="listecouchesentete">Liste des couches</div>
                <ul>
                    <li>
                        <div id="groupecouche" className="groupecouche">
                            Limites
                        </div>
                        <ul className="listecouches">
                            <li style={{ listStyleType: "none" }}>
                                <input id="couche6" className="couchecocher" type="checkbox" checked={bouchesdurhone} onChange={() => setBouchesDuRhone(!bouchesdurhone)} />Bouches-du-Rhône
                            </li>
                            <li style={{ listStyleType: "none" }}>
                                <input id="couche1" className="couchecocher" type="checkbox" checked={ct} onChange={() => setCT(!ct)} />6 CT + 3 EPCI Ouest
                            </li>
                            <li style={{ listStyleType: "none" }}>
                                <input id="couche5" className="couchecocher" type="checkbox" checked={metropole} onChange={() => setMetropole(!metropole)} />Métropole
                            </li>
                            <li style={{ listStyleType: "none" }}>
                                <input id="couche2" className="couchecocher" type="checkbox" checked={communesavecarrondissement} onChange={() => setCommunesAvecArrondissement(!communesavecarrondissement)} />Communes avec arrondissements
                            </li>
                            <li style={{ listStyleType: "none" }}>
                                <input id="couche3" className="couchecocher" type="checkbox" checked={communessansarrondissement} onChange={() => setCommunesSansArrondissement(!communessansarrondissement)} />Communes sans arrondissements
                            </li>
                            <li style={{ listStyleType: "none" }}>
                                <input id="couche4" className="couchecocher" type="checkbox" checked={polesurbain} onChange={() => setPolesUrbain(!polesurbain)} />13 pôles urbains du TdB métropolitain
                            </li>
                            <li style={{ listStyleType: "none" }}>
                                <input id="couche7" className="couchecocher" type="checkbox" checked={tachesurbaine} onChange={() => setTachesUrbaine(!tachesurbaine)} />Tâche urbaine
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            :
            null
    )
}
function mapStateToProps(state) {
    return {
        afficherlistecouches: state.afficherlistecouches,
        territoire: state.territoire
    }
}


export default connect(mapStateToProps, { setListeCouches })(ListeCouches);
